// Who a recipe is credited to. A family member can add a recipe for someone else:
// for someone on Morsel it simply becomes theirs (recipe.addedBy is the helper), and for
// someone not on Morsel it stays the helper's with recipe.credited_name ("Grandma Rose").

const firstName = (fullname) => (fullname || '').trim().split(/\s+/)[0] || ''

// The cook's name: "Grandma Rose", or the owner's name
export const creditName = (recipe) => recipe?.credited_name || recipe?.author?.fullname || ''

// "Grandma Rose's recipe, added by Sam", or the owner's name
export const creditLine = (recipe) => {
  if (!recipe?.credited_name) return recipe?.author?.fullname || ''
  const helper = firstName(recipe?.author?.fullname)
  return `${recipe.credited_name}'s recipe${helper ? `, added by ${helper}` : ''}`
}

// "Added by Sam": who added it for its owner, or for Grandma Rose. Empty for one's own recipe.
export const addedByLine = (recipe) => {
  if (recipe?.credited_name) {
    const helper = firstName(recipe?.author?.fullname)
    return helper ? `Added by ${helper}` : ''
  }
  return recipe?.addedBy?.fullname && recipe.addedBy.id !== recipe.user_id
    ? `Added by ${firstName(recipe.addedBy.fullname)}`
    : ''
}

// The person a recipe is credited to, for an avatar and name (voice memo player)
export const creditPerson = (recipe) =>
  recipe?.credited_name ? { fullname: recipe.credited_name, avatar: null } : recipe?.author
